<template>
  <div>
    <iframe
      class="position-absolute border-0"
      style="left: 0; top:0;"
      :src="url"
      height="1080"
      width="1935"
      allowfullscreen
    />
  </div>
</template>

<script>
export default {
  name: 'IframeEmbed',
  props: {
    url: {
      type: String,
      default: '',
    },
  },
};
</script>
